export const BIZHUB_FREE_MODE_MESSAGE =
  'BizHub is currently free to use. Explore the platform and enjoy its available features.';

export type ProductFocusFlags = {
  accommodation: boolean;
  bedspace: boolean;
  staycation: boolean;
  services: boolean;
  store: boolean;
  health: boolean;
  food: boolean;
  delivery: boolean;
  live_feed: boolean;
  creator_hub: boolean;
};

export const DEFAULT_PRODUCT_FOCUS: ProductFocusFlags = {
  accommodation: true,
  bedspace: true,
  staycation: true,
  services: false,
  store: false,
  health: false,
  food: false,
  delivery: false,
  live_feed: true,
  creator_hub: true,
};

export function parseProductFocus(raw: unknown): ProductFocusFlags {
  const r = raw && typeof raw === "object" ? (raw as Record<string, unknown>) : {};
  const b = (key: keyof ProductFocusFlags) =>
    typeof r[key] === "boolean" ? (r[key] as boolean) : DEFAULT_PRODUCT_FOCUS[key];
  return {
    accommodation: b("accommodation"),
    bedspace: b("bedspace"),
    staycation: b("staycation"),
    services: b("services"),
    store: b("store"),
    health: b("health"),
    food: b("food"),
    delivery: b("delivery"),
    live_feed: b("live_feed"),
    creator_hub: b("creator_hub"),
  };
}

let cached: ProductFocusFlags = { ...DEFAULT_PRODUCT_FOCUS };
let cachedFreeMode = false;
let cachedFreeModeMessage = BIZHUB_FREE_MODE_MESSAGE;

export function getProductFocus(): ProductFocusFlags {
  return cached;
}

export function isBizhubFreeMode(): boolean {
  return cachedFreeMode;
}

export function getBizhubFreeModeMessage(): string {
  return cachedFreeModeMessage;
}

export function isProductEnabled(key: keyof ProductFocusFlags): boolean {
  return Boolean(cached[key]);
}

export function setProductFocusCache(flags: ProductFocusFlags): void {
  cached = flags;
}

export async function loadProductFocus(apiOrigin: string): Promise<ProductFocusFlags> {
  try {
    const origin = apiOrigin.replace(/\/api\/?$/, "");
    const res = await fetch(`${origin}/api/public/product-focus`);
    const json = await res.json().catch(() => ({}));
    if (res.ok && json?.data) {
      cached = parseProductFocus(json.data);
      cachedFreeMode = json.data.free_mode === true;
      if (typeof json.data.free_mode_message === 'string' && json.data.free_mode_message.trim()) {
        cachedFreeModeMessage = json.data.free_mode_message.trim();
      }
    }
  } catch {
    /* keep defaults */
  }
  return cached;
}
